import { render } from "./StateHealthOrgList.vue?vue&type=template&id=159881a9&scoped=true"
import script from "./StateHealthOrgList.vue?vue&type=script&lang=js"
export * from "./StateHealthOrgList.vue?vue&type=script&lang=js"

import "./StateHealthOrgList.vue?vue&type=style&index=0&id=159881a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159881a9"]])

export default __exports__